import Container from 'react-bootstrap/Container';

export default function Author({children}){
    return (
	<Container className="author">
	    {children}
	</Container>
    );
}
